const Panel = {
  baseStyle: {
    container: {
      borderRadius: "var(--panel-border-radius, var(--vimeo-radii-modal))",
      borderWidth: "var(--panel-border-width, 1px)",
      borderStyle: "var(--panel-border-style, solid)",
      borderColor: "var(--panel-border-color, var(--vimeo-colors-stroke))",
      maxHeight: "var(--panel-max-height)",
      bg: "var(--panel-bg, var(--vimeo-colors-surface))",
      transitionProperty: "height",
      transitionDuration: ".3s",
      transitionTimingFunction: "ease-in-out",
      overflow: "hidden",
      width: "max-content"
    },
    content: {
      minWidth: "272px"
    },
    body: {
      padding: "200"
    },
    header: {
      padding: "200"
    }
  }
};

export { Panel };
